import React, { PropsWithChildren, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { TwilioError } from 'twilio-video';

interface ErrorDialogProps {
  dismissError: Function;
  error: TwilioError | null;
}

// ESTA ES LA FUNCIÓN QUE FALTABA
function enhanceMessage(message = '', code?: number) {
  switch (code) {
    case 20101:
      return message + '. Invalid credentials.';
    default:
      return message;
  }
}

function ErrorDialog({ dismissError, error }: PropsWithChildren<ErrorDialogProps>) {
  const { message, code } = error || {};
  const enhancedMessage = enhanceMessage(message, code);

  // --- LÓGICA PARA BLOQUEAR AL PARTICIPANTE ---
  useEffect(() => {
    // Si la sala se cerró (53118), activamos el bloqueo
    if (code === 53118) {
      // EL PARTICIPANTE TAMBIÉN RECIBE TICKET
      window.sessionStorage.setItem('meeting_ended', 'true');
      dismissError();
    }
  }, [code, dismissError]);

  if (code === 53118) return null;
  // ---------------------------------------------

  return (
    <Dialog open={error !== null} onClose={() => dismissError()} fullWidth={true} maxWidth="xs">
      <DialogTitle>ERROR</DialogTitle>
      <DialogContent>
        <DialogContentText>{enhancedMessage}</DialogContentText>
        {Boolean(code) && (
          <pre>
            <code>Error Code: {code}</code>
          </pre>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => dismissError()} color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorDialog;
